<div class="w-100 h-100 flex align-items-center justify-content-center" data-test-id="loading-spinner">
  <img class="rotate-animation" ngSrc="assets/images/icons/eyeQ-loading-icon.svg" height="70" width="103" alt="EyeQ logo">
</div>
